export const LANG = {
  cs: 'cs',
  en: 'en',
}

export const DATE_FORMATS = {
  ONLY_TIME_SECONDS: 'HH:mm:ss',
  ONLY_TIME: 'HH:mm',
  DATE: 'yyyy-MM-dd',
  DATE_PUBLIC: 'dd. MM. yyyy',
  DATE_PUBLIC_SHORT: 'd. M. yyyy',
}

export const WCM_PORTALS = {
  INTERNET: 'internet',
}
